import { render, staticRenderFns } from "./BuyAgreement.vue?vue&type=template&id=667d7d96&scoped=true&"
import script from "./BuyAgreement.vue?vue&type=script&lang=js&"
export * from "./BuyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./BuyAgreement.vue?vue&type=style&index=0&id=667d7d96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d7d96",
  null
  
)

export default component.exports